import Vue from 'vue'
import moment from 'moment-timezone'

Vue.filter('toGW', function (val) {
  if (!val) return ''
  var formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  })
  return formatter.format(val)
})

Vue.filter('toVW', function (val) {
  if (!val) return ''
  var formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  })
  return formatter.format(val)
})

Vue.filter('toCW', function (val) {
  if (!val) return ''
  var formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  })
  val = Math.round(val)
  return formatter.format(val)
})

Vue.filter('toCBM', function (val) {
  if (!val) return ''
  var formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  })
  return formatter.format(val)
})
Vue.filter('toPieces', function (val) {
  if (!val) return ''
  var piece = parseInt(val)
  return piece.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})

Vue.filter('toMoney', function (val) {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
  return formatter.format(val)
})
Vue.filter('toRate', function (val) {
  var formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
  return formatter.format(val)
})
Vue.filter('toCm', function (val) {
  var formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  })
  return formatter.format(val)
})
Vue.filter('toLogikons', function (val) {
  var number = parseInt(val)
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})
Vue.filter('toDate', function (val) {
  if (val) {
    return moment(String(val)).format('YYYY-MM-DD hh:mm')
  }
})
Vue.filter('toDays', function (val) {
  var number = parseInt(val)
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})
Vue.filter('toPercentage', function (val) {
  var formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
  return `${formatter.format(val)}%`
})
Vue.filter('toDensity', function (val) {
  if (!val) return ''
  var number = parseInt(val)
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})

Vue.filter('toExchange', function (val) {
  var formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4
  })
  return formatter.format(val)
})

Vue.filter('toFormat', function (date, format = 'YYYY-MM-DD HH:mm:ss') {
  const language = localStorage.getItem('locale') || 'EN'
  moment.locale(language)
  return moment.utc(date).format(format)
})

Vue.filter('cutDigits', function (val) {
  let textFormatted = ''
  if (val !== '') textFormatted = val.substring(0, val.length - 1)
  return textFormatted
})
Vue.filter('toCurrency', function (value, currency = 'USD', currencyID = null) {
  if (typeof value !== 'number') {
    return value
  }
  if (currencyID) {
    switch (currencyID) {
      case 1:
        currency = 'MXN'
        break
      case 2:
        currency = 'USD'
        break
      case 3:
        currency = 'EUR'
        break
      default:
        currency = ''
    }
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0
  })
  return formatter.format(value)
})

Vue.filter('usFormat', (value) => {
  if (typeof value !== 'number') {
    return value
  }
  const numberFormat = new Intl.NumberFormat('en-US')
  return numberFormat.format(value)
})
